<template>
    <div class="cps-main-page">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item
            ><i class="el-icon-s-home"></i>首页
            </el-breadcrumb-item
            >
            <el-breadcrumb-item>游戏管理</el-breadcrumb-item>
            <el-breadcrumb-item>游戏审核</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider></el-divider>
        <div class="page-content">
            <el-row @keyup.enter.native="loadData(1)">
                <el-input
                    v-model="queryField.auditId"
                    size="small"
                    placeholder="审核ID"/>
                <el-input
                    v-model="queryField.adminId"
                    size="small"
                    placeholder="会长ID"/>
                <el-input
                    v-model="queryField.gameId"
                    size="small"
                    placeholder="游戏ID"/>
                <el-input
                    v-model="queryField.auditAdminId"
                    size="small"
                    placeholder="操作人ID"/>
                <el-select
                    v-model="queryField.auditStatus"
                    size="small"
                    placeholder="审核状态">
                    <el-option label="待审核" value="1"/>
                    <el-option label="通过" value="2"/>
                    <el-option label="驳回" value="3"/>
                </el-select>
                <el-button type="primary" size="small" @click="loadData(1)">查询</el-button>
                <el-button size="small" @click="reset">重置</el-button>
            </el-row>

            <el-table
                class="cps-table-data"
                :data="tableData"
                size="small"
                v-loading=loading
                border
                :height="height"
                style="width: 100%">
                <el-table-column
                    prop="audit_id"
                    label="审核ID"
                    width="60">
                </el-table-column>
                <el-table-column
                    prop="admin_id"
                    label="会长ID"
                    width="60">
                </el-table-column>
                <el-table-column
                    prop="admin_name"
                    label="会长名称"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="game_id"
                    label="游戏ID"
                    width="60">
                </el-table-column>
                <el-table-column
                    prop="game_name"
                    label="游戏名"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="audit_admin_id"
                    label="操作人ID"
                    width="90">
                </el-table-column>
                <el-table-column
                    prop="audit_status"
                    :formatter="auditStatusFormat"
                    label="审核状态"
                    width="90">
                </el-table-column>
                <el-table-column
                    prop="add_time"
                    label="申请时间"
                    width="150">
                </el-table-column>
                <el-table-column
                    width="280"
                    label="操作">
                    <template slot-scope="scope">
                        <el-button @click="throughAudit(scope.row.audit_id,scope.row.game_id)" type="text" size="small">通过</el-button>
                        <el-button @click="reject(scope.row.audit_id)" type="text" size="small">驳回</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="cps-table-data"
                @current-change="loadData"
                background
                :page-size="pageSize"
                :current-page="currentIndex"
                layout="total, prev, pager, next"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { queryAuditList,setPassed,setStatusReject } from '@/api/request'

export default {
    name: "gameAuditList",
    data() {
        return {
            queryField: {
                auditId: '',
                adminId: '',
                gameId: '',
                auditAdminId: '',
                auditStatus: '',
            },
            tableData: [],
            total: 0,
            height: window.innerHeight - 220,
            pageSize: 15,
            currentIndex: 1,
            loading: false,
        }
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(index) {
            this.loading = true;
            let params = {
                pageNo: index,
                pageSize: this.pageSize,
                params: this.queryField
            }
            queryAuditList(params).then(res => {
                this.loading = false;
                this.tableData = res.data.list
                this.total = res.data.total
                this.currentIndex = index
            })
        },
        throughAudit(auditId,gameId){
            let params = {
                auditId: auditId,
                gameId: gameId
            }
            setPassed(params).then(res => {
                if(res.data.success){
                    this.$message.success('操作成功');
                    this.loadData(1);
                }else {
                    this.$message.error(res.data.error.message);
                }
            })
        },
        reject(auditId){
            setStatusReject(auditId).then(res => {
                if(res.data.success){
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    this.loadData(1);
                }
                else {
                    this.$message({
                        message: res.data.error.message,
                        type: 'error'
                    });
                }
            })
        },
        reset() {
            this.queryField = {
                auditId: '',
                adminId: '',
                gameId: '',
                auditAdminId: '',
                auditStatus: '',
            }
            this.loadData(1);
        },
        auditStatusFormat(row, column, cellValue){
            let ret = '';
            if(cellValue === 1){
                ret = '待审核';
            }else if(cellValue === 2){
                ret = '通过';
            }else if(cellValue === 3){
                ret = '驳回'
            }
            return ret;
        }
    }
}
</script>

<style scoped>

</style>